import { EmployerAgreementSourcesService_employerAgreementSourcesServiceGetEntity } from '@festina/life-general-types/life/hooks/EmployerAgreementSourcesService_employerAgreementSourcesServiceGetEntity'

export const useLazyExportEmployerAgreement =
  EmployerAgreementSourcesService_employerAgreementSourcesServiceGetEntity.useLazyQuery
